type TrackingEvent = 'page_view' | 'category_click' | 'whatsapp_redirect';

interface TrackingData {
  category?: string;
  subcategory?: string;
  section?: string;
  timestamp?: string;
  [key: string]: string | undefined;
}

export const trackEvent = (event: TrackingEvent, data: TrackingData = {}): void => {
  const payload = {
    event,
    timestamp: new Date().toISOString(),
    ...data,
  };
  // Mock tracking — replace with real analytics (GA, Meta Pixel, etc.)
  console.info(`[KampanyaKupon Track] ${event}`, payload);
};
